import combineReducers from 'combine-reducers-global-state';
import CurrenciesReducer from './CurrenciesReducer';
import MutationsReducer from './MutationsReducer';
import UiReducer from './UiReducer';
import BaseReducer from './BaseReducer';
import HomepageReducer from './HomepageReducer';
import RaffleDetailReducer from './RaffleDetailReducer';
import RaffleFormReducer from './RaffleFormReducer';
import SubscribeReducer from './SubscribeReducer';
import reduceReducers from 'reduce-reducers';
import { NORMALIZE_INITIAL_DATA_ACTION } from '../actions/UtilityActions';
import ShippingPageReducer from './ShippingPageReducer';
import AdyenPaymentReducer from './AdyenPaymentReducer';
import FeatureSwitchReducer from './FeatureSwitchReducer';

export default class RootReducer extends BaseReducer {

	/**
	 * Map of reducers
	 *
	 * @return {*}
	 */
	static get reducers() {
		return {
			currencies: CurrenciesReducer,
			mutations: MutationsReducer,
			homepage: HomepageReducer,
			raffleDetail: RaffleDetailReducer,
			raffleForm: RaffleFormReducer,
			subscribe: SubscribeReducer,
			shippingPage: ShippingPageReducer,
			ui: UiReducer,
			adyenPayment: AdyenPaymentReducer,
			featureSwitch: FeatureSwitchReducer
		};
	}

	/**
	 * @param {object} state
	 * @param {object} action
	 */
	static normalizeInitialData(state, action) {
		if (action.type === NORMALIZE_INITIAL_DATA_ACTION) {
			return RootReducer.normalize(state);
		}

		return state;
	}

	/**
	 * Map of normalizers
	 *
	 * @return {*}
	 */
	static get normalizers() {
		return RootReducer.reducers;
	}
}

/**
 * Method created by combining of reducers
 */
RootReducer.reduce = reduceReducers(
	RootReducer.normalizeInitialData,
	combineReducers(
		Object.keys(RootReducer.reducers).reduce(
			(combinedReducers, key) => {
				combinedReducers[key] = RootReducer.reducers[key].reduce;
				return combinedReducers;
			},
			{}
		)
	)
);



// WEBPACK FOOTER //
// ./reducers/RootReducer.js